var _a;
import { mailIdinList, getMailListByIdFromStore, getMainAccount, isMainAccount, getTreeId2Node, getChooseMailId, getFixedMailHead, treeDFS } from '../../../util';
import { cloneDeep } from 'lodash';
import { guideConfig } from '../../config';
import { getCanActiveMailId, updateMailStore, updateMailStoreNoMerge, separateUpdateIdAndStore, formatMailDataList, getIsSearchingMailByState, filterNotMainFolder, } from '../../customize';
import { MAIL_STORE_REDUX_STATE, FLOLDER, LIST_MODEL, filterTabMap, MAIL_LIST_CHOOSE_TYPE, FOLDER_EXPAND_ACCOUNT, MAIL_FOLDER_SELECTED_LOCAL_KEY, } from '../../../common/constant';
import { reducerHelper } from '@web-mail/state/slice/mailReducer/helper';
import _set from 'lodash/set';
import { getStateFromLocalStorage } from '@web-mail/hooks/useUserLocalStorageState';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { apiHolder as api, apis } from 'api';
import { customerReducers } from '@web-mail/state/slice/customerMailReducer/reducers';
import { subordinateReducers } from '@web-mail/state/slice/subordinateMailReducer/reducers';
import { tabId } from '@web-common/state/reducer/mailTabReducer';
import { genCustomerState } from '@web-mail/state/slice/customerMailReducer/states';
import { genSubordinateState } from '@web-mail/state/slice/subordinateMailReducer/states';
import { getIn18Text } from 'api';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const storageApi = api.api.getDataStoreApi();
let lastSelectedFolder = null;
try {
    let res = (_a = storageApi.getSync(MAIL_FOLDER_SELECTED_LOCAL_KEY)) === null || _a === void 0 ? void 0 : _a.data;
    if (res) {
        const config = JSON.parse(res);
        if (config && config.id) {
            lastSelectedFolder = config;
        }
    }
}
catch (e) {
    console.error('[error] lastSelectedFolder local', e);
}
const defaultSelectedKeys = {
    id: FLOLDER.DEFAULT,
    accountId: getMainAccount(),
};
const defaultGuidePageStatus = (() => {
    const status = {
        1: '',
        3: '',
        '-1': '',
        '-100': '',
    };
    const key = defaultSelectedKeys.id;
    status[key] = guideConfig[key].sort[0];
    return status;
})();
const defaultGuidePage = (() => {
    const key = defaultSelectedKeys.id;
    const type = guideConfig[key].sort[0];
    return guideConfig[key].config[type];
})();
export const mainAccountState = {};
export const defaultTreeState = {
    mailFolderTreeList: [],
    MailFolderTreeMap: {},
    expandedKeys: [FLOLDER.OTHERS, FLOLDER.STAR],
    hasCustomFolder: false,
    sort: 0,
    accountId: '',
    emailType: '',
    expired: false,
    allReadLoadingMap: {},
    mailTagList: [],
    accountName: '',
    wmDeliveryTagUnRead: {
        __deliveryrecord__: 0,
        __delivery__: 0,
    },
};
export const defaultSelectedMailId = {
    id: '',
    accountId: '',
};
const getMailAccountInitTreeState = () => {
    var _a;
    const state = cloneDeep(defaultTreeState);
    const localExpandKeys = getStateFromLocalStorage(FOLDER_EXPAND_ACCOUNT);
    if (((_a = localExpandKeys === null || localExpandKeys === void 0 ? void 0 : localExpandKeys.main) === null || _a === void 0 ? void 0 : _a.length) && Array.isArray(localExpandKeys === null || localExpandKeys === void 0 ? void 0 : localExpandKeys.main)) {
        state.expandedKeys = [...new Set([...state.expandedKeys, ...localExpandKeys === null || localExpandKeys === void 0 ? void 0 : localExpandKeys.main])];
    }
    return state;
};
export const MailBoxInitialState = {
    mainAccountState: cloneDeep(mainAccountState),
    childAccountStateMap: {},
    mailTreeStateMap: {
        main: getMailAccountInitTreeState(),
    },
    mailTreeLocalLoadingMap: {},
    mailTreeNetworkLoadingMap: {},
    expiredAccountList: [],
    loginingSubAccountList: [],
    accountActiveKey: [],
    mailSearchMoreAccounts: false,
    mailSearchAccount: '',
    mailSearchKey: '',
    mailSearching: '',
    mailSearchStateMap: {},
    mailSearchType: 'all',
    mailSearchRecord: true,
    mailSearchFolderIds: [],
    isSearchRecorded: false,
    advancedSearchVisible: false,
    advancedSearchLoading: false,
    advanceSearchFromValues: {},
    searchList: [],
    selectedSearchKeys: {},
    defaultSelectedSearchKeyMap: {},
    searchListStateTab: 'ALL',
    searchResultObj: {
        total: 20,
    },
    extraSearchCloudMailListObj: {},
    extraSearchCloudMailListObjStatus: '',
    activeSearchMailId: Object.assign({}, defaultSelectedMailId),
    searchingRequestId: null,
    mailTagFolderActiveKey: {
        key: null,
        accountId: '',
    },
    [MAIL_STORE_REDUX_STATE]: {},
    searchLoading: true,
    listLoading: true,
    selectedKeys: lastSelectedFolder ? Object.assign({}, (lastSelectedFolder || defaultSelectedKeys)) : Object.assign({}, defaultSelectedKeys),
    refreshBtnLoading: false,
    isDragModel: null,
    expandedSearchKeys: [],
    mailDataList: [],
    refreshHasNewMail: false,
    mailTotal: 0,
    activeIds: [],
    commonModalVisible: false,
    mailListStateTab: 'ALL',
    scrollTop: 0,
    folderTreeDragModel: null,
    folderModveModalVisiable: false,
    folderMoveId: null,
    folderSortModalVisiable: false,
    folderSortModalData: {
        parentId: null,
        folders: [],
    },
    importFolderId: null,
    mailFolderIsLock: false,
    mailMoveModalVisiable: false,
    mailImportModalVisible: false,
    mailMoveFid: null,
    mfModalSelectedFids: [],
    mfModalExpandFids: [],
    mailAITidyUpModalVisiable: false,
    AISelectModalExpandFids: [],
    AISelectModalSelectedFids: [],
    mailTabs: filterTabMap.normal,
    selectedMailId: Object.assign({}, defaultSelectedMailId),
    refreshLoading: false,
    noticeNum: 0,
    keepPeriod: 30,
    mailListResizeProcessing: false,
    mailMoveMid: { mailId: [], accountId: '' },
    mailImportMid: '',
    mailMoveIsThread: false,
    mailTagAddModalVisible: {
        accountId: '',
        visible: false,
    },
    mailMultPanelVisible: false,
    mfModalReadMailNum: 0,
    mailListInitIsFailed: false,
    dialogConfig: null,
    guidePageStatus: defaultGuidePageStatus,
    onGuidePage: defaultGuidePage,
    mailListMenuVisiable: false,
    activeFolderList: [],
    showThreadBuildingTip: false,
    showStarContactBuildingTip: false,
    showGlobalLoading: false,
    hideMessage: false,
    successMsg: '',
    failMsg: '',
    shareMail: {},
    shareMailMid: '',
    readMailChildMailList: [],
    readMailWindowActiveMailId: null,
    mailRelateActiveMialId: null,
    mailRelateMailList: [],
    activeStrangerIds: [],
    mailRelateStrangerActiveId: '',
    mailRelateStrangeMailList: [],
    mailExcludeKeyMap: {},
    defaultMailListSelectedModel: LIST_MODEL.INIT,
    mailMenuItemState: {},
    edmFollowUpTipShow: false,
    configMailShow: false,
    configMailFocusId: '',
    configMailListShowAvator: true,
    configMailListShowConcreteTime: false,
    configMailLayout: '1',
    configMailListShowAttachment: true,
    configMailListShowDesc: true,
    configMailListTightness: 2,
    configMailListShowCustomerTab: true,
    configCustomerCompany: false,
    configMailListShowRedFlagBg: false,
    uniCustomerParam: { visible: false, source: 'mailListStrangerSideBar' },
    uniOpportunityParam: { visible: false },
    uniClueParam: { visible: false },
    uniToCustomerOrClueParam: { visible: false },
    uniClueViewParam: { visible: false },
    unReadMap_cm: { customerMap: {}, contentMap: {} },
    newGuideForCustomerAside_cm: false,
    rightSideSelectedDetail: {
        email: '',
        name: '',
    },
    customer: {
        [tabId.readCustomer]: genCustomerState(),
    },
    subordinate: {
        [tabId.subordinate]: genSubordinateState(),
    },
    customerAsideDetail: {
        email: '',
        type: '',
    },
    orderDateRange: {
        endDate: '2023-01-15',
        startDate: '2022-12-17',
    },
    commonAsideDetail: {
        aiDetailMap: {},
        aiMidMap: {},
    },
    useRealList: mailConfApi.getIsUseRealListSync(),
    realListDefaultPageSize: 20,
    realListPageSizes: ['10', '20', '30', '40', '50', '100'],
    realListCurrentPageSize: mailConfApi.getMailRealListPageSize() || 20,
    realListCurrentPage: 1,
    lastFetchFirstIndexTime: 0,
    addContactModelVisiable: false,
    listIsRefresh: false,
    suppressAdvancedRefillOnce: false,
    mergeMailOrderDesc: true,
    mailAccountAliasMap: {},
    fixedReadMailHeader: getFixedMailHead(),
    advancedSearchParam: null,
    searchParam: null,
    batchDeleteLoadingMap: {},
    AllFolderData: [],
    AllFolderDataOrigin: {},
    AllFolderDataOriginAccountIds: [],
    otherClusterNode: [],
    groupCollapseKeys: [],
    searchGroupCollapseKeys: [],
    cmgroupCollapseKeys: [],
    cmsearchGroupCollapseKeys: [],
    aiAssistSideBarVisiable: false,
    currentFolderUnReadCount: 0,
    currentMergeMailId: '',
    mailTPDetailQuery: {},
    edmShowContactDetail: false,
    aiAssistSideBarVisiable_sd: { visiable: false, time: +new Date() },
    aiAssistSideBarEnable_sd: false,
    staffRelations_sd: [],
    aiAssistSideBarEnable_resign: false,
    staffRelations_resign: [],
    aiAssistSideBarEnable_admin: false,
    hasShowAiAssistSideBar_sd: false,
    controlModalVisible_sd: false,
    controlModalHasRules_sd: false,
    AI_tab_listLoading: false,
    AI_tab_scrollTop: 0,
    AI_tab_mailListMenuVisiable: false,
    AI_tab_refreshLoading: false,
    AI_tab_selectedMailId: Object.assign({}, defaultSelectedMailId),
    AI_tab_mailTotal: 0,
    AI_tab_mailListInitIsFailed: false,
    AI_tab_groupCollapseKeys: [],
};
const staticSlice = Object.assign(Object.assign(Object.assign({ updateBatchDeleteLoadin(state, action) {
        const { key, value } = action.payload;
        state.batchDeleteLoadingMap = Object.assign(Object.assign({}, state.batchDeleteLoadingMap), { [key]: value });
    },
    updateSearchParam(state, action) {
        state.searchParam = action.payload;
    },
    updateAdvancedSearchParam(state, action) {
        state.advancedSearchParam = action.payload;
    },
    doUpdateConfigMailListShowCustomerTab(state, action) {
        state.configMailListShowCustomerTab = action.payload;
    },
    doUpdateConfigMailListShowRedFlagBg(state, action) {
        state.configMailListShowRedFlagBg = action.payload;
    },
    doUpdateUseRealList(state, action) {
        state.useRealList = action.payload;
    },
    doUpdateRealListPageSize(state, action) {
        if (action.payload && action.payload.pageSize) {
            state.realListCurrentPageSize = action.payload.pageSize;
        }
    },
    doUpdateRealListPage(state, action) {
        if (action.payload && action.payload.page) {
            state.realListCurrentPage = action.payload.page;
        }
    }, doUpdateAny: (state, action) => {
        const { name, data } = action.payload || {};
        if (name && state && state[name] !== undefined) {
            try {
                state[name] = data;
            }
            catch (e) {
                console.warn('[doUpdateAny Error]', name, e);
            }
        }
        else {
            console.warn('[doUpdateAny Error]', name);
        }
    } }, customerReducers), subordinateReducers), { doUpdateConfigMailShow: (state, action) => {
        state.configMailShow = action.payload;
    }, doUpdateConfigMailFocusId: (state, action) => {
        state.configMailFocusId = action.payload;
    }, doUpdateConfigMailListShowAttachment: (state, action) => {
        state.configMailListShowAttachment = action.payload;
    }, doUpdateConfigMailListTightness: (state, action) => {
        state.configMailListTightness = action.payload;
    }, doUpdateConfigMailListShowDesc: (state, action) => {
        state.configMailListShowDesc = action.payload;
    }, doUpdateConfigMailListShowAvator: (state, action) => {
        state.configMailListShowAvator = action.payload;
    }, doUpdateConfigMailListShowConcreteTime: (state, action) => {
        state.configMailListShowConcreteTime = action.payload;
    }, doUpdateConfigMailLayout: (state, action) => {
        state.configMailLayout = action.payload;
    }, doUpdateMailSearchLoading: (state, action) => {
        state.searchLoading = action.payload;
    }, doUpdateMailListLoading: (state, action) => {
        state.listLoading = action.payload;
    }, doUpdateMailTagList: (state, action) => {
        const { accountId, value = [] } = action.payload;
        const isMain = isMainAccount(accountId);
        if (accountId && !isMain) {
            state.mailTreeStateMap[accountId]['mailTagList'] = value;
        }
        else {
            state.mailTreeStateMap.main.mailTagList = value;
        }
        state.mailTreeStateMap = Object.assign({}, state.mailTreeStateMap);
    }, doUpdateSelectedSearchKey: (state, action) => {
        state.selectedSearchKeys = action.payload;
    }, doUpdateDefaultSelectedSearchKeyMap: (state, action) => {
        state.defaultSelectedSearchKeyMap = action.payload;
    }, doUpdateSearchResultObj: (state, action) => {
        state.searchResultObj = action.payload;
    }, doUpdateSelectedKey: (state, action) => {
        var _a;
        state.realListCurrentPage = 1;
        let res = action.payload;
        if (!((_a = action.payload) === null || _a === void 0 ? void 0 : _a.accountId)) {
            res = Object.assign(Object.assign({}, action.payload), { accountId: getMainAccount() });
            state.selectedKeys = res;
        }
        else {
            state.selectedKeys = res;
        }
        try {
            storageApi.putSync(MAIL_FOLDER_SELECTED_LOCAL_KEY, JSON.stringify(res));
        }
        catch (e) {
            console.error('[error] doUpdateSelectedKey local', e);
        }
    }, doUpdateTaskMailListStateTab: (state, action) => {
        state.mailListStateTab = action.payload;
    }, doUpdateRefershBtnLoading: (state, action) => {
        state.refreshBtnLoading = action.payload;
    }, doUpdateMailTagFolderActiveKey: (state, action) => {
        const { accountId = '', key } = action.payload;
        state.mailTagFolderActiveKey = {
            key: key,
            accountId: accountId,
        };
    }, doUpdateAdvancedSearchVisible: (state, action) => {
        state.advancedSearchVisible = action.payload;
    }, doUpdateExpandedSearchKeys: (state, action) => {
        state.expandedSearchKeys = action.payload;
    }, doUpdateMainTreeExpandedKeys: (state, action) => {
        state.mailAccountTreeState.expandedKeys = action.payload;
    }, doUpdateSeatchList: (state, action) => {
        const list = formatMailDataList(action.payload);
        separateUpdateIdAndStore(state, 'searchList', list);
    }, doUpdateMailDataList: (state, action) => {
        const list = formatMailDataList(action.payload);
        separateUpdateIdAndStore(state, 'mailDataList', list);
    }, doUpdateMailTotal: (state, action) => {
        state.mailTotal = action.payload;
    }, doUpdateRefreshHasNewMail: (state, action) => {
        state.refreshHasNewMail = action.payload;
    }, doUpdateActiveIds: (state, action) => {
        state.activeIds = action.payload;
    }, doUpdateCommonModalVisible: (state, action) => {
        state.commonModalVisible = action.payload;
    }, doUpdateMailListStateTab: (state, action) => {
        state.mailListStateTab = action.payload;
    }, doUpdateMailListScrollTop: (state, action) => {
        state.scrollTop = action.payload;
    }, doUpdateSearchListStateTab: (state, action) => {
        state.searchListStateTab = action.payload;
    }, doUpdateFolderTreeDragModel: (state, action) => {
        state.folderTreeDragModel = action.payload;
    }, doUpdateFolderModveModalVisiable: (state, action) => {
        state.folderModveModalVisiable = action.payload;
    }, doUpdateFolderMoveId: (state, action) => {
        state.folderMoveId = action.payload;
    }, doUpdateFolderSortModalVisiable: (state, action) => {
        state.folderSortModalVisiable = action.payload;
    }, doUpdateFolderSortData: (state, action) => {
        state.folderSortModalData = Object.assign(Object.assign({}, state.folderSortModalData), action.payload);
    }, doUpdateImportFolderId: (state, action) => {
        state.importFolderId = action.payload;
    }, doUpdateMailCustomFolderTreeList: () => {
    }, doUpdateMailSearchMoreAccounts: (state, action) => {
        state.mailSearchMoreAccounts = action.payload;
    }, doUpdateMailSearchAccount: (state, action) => {
        state.mailSearchAccount = action.payload;
    }, doUpdateMailSearchKey: (state, action) => {
        state.mailSearchKey = action.payload;
    }, doUpdateMailSearchType: (state, action) => {
        state.mailSearchType = action.payload;
    }, doUpdateMailSearching: (state, action) => {
        state.mailSearching = action.payload;
    }, doUpdateMailSearchStateMap: (state, action) => {
        state.mailSearchStateMap = action.payload;
    }, doUpdateMailSearchRecord: (state, action) => {
        state.mailSearchRecord = action.payload;
    }, doUpdateMailSearchFolderIds: (state, action) => {
        state.mailSearchFolderIds = action.payload;
    }, doUpdateActiveSearchMailId: (state, action) => {
        state.activeSearchMailId = action.payload;
    }, doUpdateMailFolderIsLock: (state, action) => {
        state.mailFolderIsLock = action.payload;
    }, doUpdateAdvancedSearchLoading: (state, action) => {
        state.advancedSearchLoading = action.payload;
    }, doUpdateMailMoveModalVisiable: (state, action) => {
        state.mailMoveModalVisiable = action.payload;
    }, doUpdateMailImportModalVisible: (state, action) => {
        state.mailImportModalVisible = action.payload;
    }, doUpdateMailMoveFid: (state, action) => {
        state.mailMoveFid = action.payload;
    }, doUpdateMfModalSelectedFids: (state, action) => {
        state.mfModalSelectedFids = action.payload;
    }, doUpdateMfModalExpandFids: (state, action) => {
        state.mfModalExpandFids = action.payload;
    }, doUpdateMailAITidyUpModalVisiable: (state, action) => {
        state.mailAITidyUpModalVisiable = action.payload;
    }, doUpdateMailTabs: (state, action) => {
        state.mailTabs = action.payload;
    }, doUpdateSelectedMail: (state, action) => {
        state.selectedMailId = action.payload;
        state.currentMergeMailId = '';
    }, doUpdateRefreshLoading: (state, action) => {
        state.refreshLoading = action.payload;
    }, doUpdateNoticeNum: (state, action) => {
        state.noticeNum = action.payload;
    }, doUpdateKeepPeriod: (state, action) => {
        state.keepPeriod = action.payload;
    }, doUpdateMailListResizeProcessing: (state, action) => {
        state.mailListResizeProcessing = action.payload;
    }, doUpdateMailMoveMid: (state, action) => {
        state.mailMoveMid = action.payload;
    }, doUpdateMailImportMid: (state, action) => {
        state.mailImportMid = action.payload;
    }, doUpdateMailMoveIsThread: (state, action) => {
        state.mailMoveIsThread = action.payload;
    }, doUpdateMailTagAddModalVisible: (state, action) => {
        state.mailTagAddModalVisible = action.payload;
    }, doUpdateMailMultPanelVisible: (state, action) => {
        state.mailMultPanelVisible = action.payload;
    }, doUpdateMfModalReadMailNum: (state, action) => {
        state.mfModalReadMailNum = action.payload;
    }, doUpdateMailListInitIsFailed: (state, action) => {
        state.mailListInitIsFailed = action.payload;
    }, doUpdatedialogConfig: (state, action) => {
        state.dialogConfig = action.payload;
    }, doUpdateMailListMenuVisiable: (state, action) => {
        state.mailListMenuVisiable = action.payload;
    }, doUpdateActiveFolderList: (state, action) => {
        state.activeFolderList = action.payload;
    }, doUpdateShowTbTip: (state, action) => {
        state.showThreadBuildingTip = action.payload;
    }, doUpdateShowGlobalLoading: (state, action) => {
        state.showGlobalLoading = action.payload;
    }, doUpdateAdvanceSearchFromValues: (state, action) => {
        state.advanceSearchFromValues = action.payload;
    }, doUpdateIsSearchRecordeds: (state, action) => {
        state.isSearchRecorded = action.payload;
    }, doUpdateMsgHideMessage: (state, action) => {
        state.hideMessage = action.payload;
    }, doUpdateMsgSuccessStr: (state, action) => {
        state.successMsg = action.payload;
    }, doUpdateMsgFailStr: (state, action) => {
        state.failMsg = action.payload;
    }, doUpdateShareMail: (state, action) => {
        state.shareMail = action.payload;
    }, doUpdateShareMailMid: (state, action) => {
        state.shareMailMid = action.payload;
    }, doUpdateReadMailWindowActiveMailId: (state, action) => {
        state.readMailWindowActiveMailId = action.payload;
    }, doUpdateMailRelateActiveMialId: (state, action) => {
        state.mailRelateActiveMialId = action.payload;
    }, doUpdateMailRelateStrangerActiveId: (state, action) => {
        state.mailRelateStrangerActiveId = action.payload;
    }, doUpdateActiveStrangerIds: (state, action) => {
        state.activeStrangerIds = action.payload;
    }, doUpdateMailRelateMailList: (state, action) => {
        state.mailRelateMailList = action.payload;
    }, doUpdateMailListSelectedModel: (state, action) => {
        state.defaultMailListSelectedModel = action.payload;
    }, doUpdateListIsRefresh: (state, action) => {
        state.listIsRefresh = action.payload;
    }, doUpdateSuppressAdvancedRefillOnce: (state, action) => {
        state.suppressAdvancedRefillOnce = action.payload;
    }, doUpdateMailTreeState: (state, action) => {
        var _a, _b, _c;
        const { accountId, name, value } = action.payload;
        const isMain = isMainAccount(accountId);
        if (accountId && !isMain) {
            if (name === 'mailFolderTreeList') {
                if (((_a = state.mailTreeStateMap[accountId]) === null || _a === void 0 ? void 0 : _a.MailFolderTreeMap) && ((_b = state.mailTreeStateMap[accountId]) === null || _b === void 0 ? void 0 : _b.hasCustomFolder)) {
                    const _value = filterNotMainFolder(value);
                    state.mailTreeStateMap[accountId].mailFolderTreeList = _value;
                    state.mailTreeStateMap[accountId].MailFolderTreeMap = getTreeId2Node(_value);
                    state.mailTreeStateMap[accountId].hasCustomFolder = (() => {
                        let found = false;
                        treeDFS(_value, (item) => {
                            var _a;
                            if (Number((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId) >= 100) {
                                found = true;
                            }
                        });
                        return found;
                    })();
                }
            }
            else if (name == 'expandedKeys') {
                state.mailTreeStateMap[accountId][name] = value.filter((item) => item != FLOLDER.TASK && item != FLOLDER.WAITINGISSUE && item != FLOLDER.READYISSUE && item != FLOLDER.DEFER);
            }
            else if (name == 'remKey') {
                delete state.mailTreeStateMap[accountId];
            }
        }
        else {
            if (name === 'mailFolderTreeList') {
                if (state.mailTreeStateMap.main.MailFolderTreeMap && state.mailTreeStateMap.main.hasCustomFolder) {
                    state.mailTreeStateMap.main.mailFolderTreeList = value;
                    state.mailTreeStateMap.main.MailFolderTreeMap = getTreeId2Node(value);
                    state.mailTreeStateMap.main.hasCustomFolder = (() => {
                        let found = false;
                        treeDFS(value, (item) => {
                            var _a;
                            if (Number((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId) >= 100) {
                                found = true;
                            }
                        });
                        return found;
                    })();
                }
            }
            else if (name == 'expandedKeys') {
                state.mailTreeStateMap.main[name] = value;
            }
        }
        if (name == 'expandedKeys') {
            try {
                const localCace = {};
                for (let key in state.mailTreeStateMap) {
                    localCace[key] = state.mailTreeStateMap[key].expandedKeys;
                }
                const serializedState = JSON.stringify(localCace);
                storageApi.putSync(FOLDER_EXPAND_ACCOUNT, serializedState);
            }
            catch (e) {
                console.error('[Error thunk FOLDER_EXPAND_ACCOUNT]', e);
            }
        }
        if (name == 'selectedKeys') {
            let res = action.payload;
            if (!((_c = action.payload) === null || _c === void 0 ? void 0 : _c.accountId)) {
                res = Object.assign(Object.assign({}, action.payload), { accountId: getMainAccount() });
            }
            try {
                storageApi.putSync(MAIL_FOLDER_SELECTED_LOCAL_KEY, JSON.stringify(res));
            }
            catch (e) {
                console.error('[error] doUpdateSelectedKey local', e);
            }
        }
        state.mailTreeStateMap = Object.assign({}, state.mailTreeStateMap);
    }, doUpdateExpiredAccountList: (state, action) => {
        state.expiredAccountList = action.payload;
    }, doUpdateLoginingSubAccountList: (state, action) => {
        state.loginingSubAccountList = action.payload;
    }, doAddLoginingSubAccount: (state, action) => {
        const emails = action.payload;
        if (!emails || !emails.length)
            return;
        const existList = state.loginingSubAccountList;
        const addList = [];
        emails.forEach(email => {
            const emailExisted = existList.find(item => item === email);
            if (!emailExisted) {
                addList.push(email);
            }
        });
        state.loginingSubAccountList = [...existList, ...addList];
    }, doRemoveLoginingSubAccount: (state, action) => {
        const email = action.payload;
        if (!email)
            return;
        const existList = state.loginingSubAccountList;
        if (!existList || !existList.length)
            return;
        state.loginingSubAccountList = state.loginingSubAccountList.filter(item => item !== email);
    }, doUpdateAccountActiveKey: (state, action) => {
        state.accountActiveKey = action.payload;
    }, reseOnSearchChange: (state, action) => {
        const { mailSearchStateMap } = state;
        if (Object.values(mailSearchStateMap).some(item => item === 'server' || item === 'local')) {
            mailApi.doClearSearchCache();
        }
    }, resetExtraSearchCloudMailList: (state) => {
        state.extraSearchCloudMailListObj = {};
        state.extraSearchCloudMailListObjStatus = '';
    }, onSearchMailUpdateTreeStateMap: (state, action) => {
        const { mailSearchStateMap, mailSearching } = state;
        const { account, value } = action.payload;
        state.mailSearchAccount = account;
        state.mailSearchKey = value;
        state.mailSearching = 'normal';
        state.mailSearchStateMap = Object.assign(Object.assign({}, mailSearchStateMap), { [account]: mailSearchStateMap[account] || 'local' });
    }, beforeSearchServer: (state, action) => {
        const { defaultSelectedSearchKeyMap, selectedSearchKeys, mailSearchStateMap } = state;
        const { account, useRealList, value } = action.payload;
        state.mailSearchStateMap = Object.assign(Object.assign({}, mailSearchStateMap), { [account]: 'server' });
        if (useRealList) {
            state.realListCurrentPage = 1;
            state.mailSearching = 'normal';
            if (value) {
                state.mailSearchKey = value;
            }
        }
        const defaultSelectedKey = Object.assign({}, defaultSelectedSearchKeyMap);
        delete defaultSelectedKey[account];
        const selectedKeys = Object.assign({}, selectedSearchKeys);
        delete selectedKeys[account];
        state.selectedSearchKeys = selectedKeys;
        state.defaultSelectedSearchKeyMap = defaultSelectedKey;
        state.mailSearchAccount = account;
        state.mailSearchFolderIds = [];
    }, doUpdateStateByURL: (state, action) => {
        const payload = action.payload;
        if (payload) {
            if (Array.isArray(payload)) {
                const list = payload;
                list.forEach(item => {
                    const { keyPath, value } = item || {};
                    _set(state, keyPath, value);
                });
            }
            else {
                const { keyPath, value } = payload;
                _set(state, keyPath, value);
            }
        }
    }, doUpdateAiAssistVisiable: (state, action) => {
        state.aiAssistSideBarVisiable = action.payload;
        if (!!action.payload && !!state.aiAssistSideBarVisiable_sd.visiable) {
            state.aiAssistSideBarVisiable_sd = { visiable: false, time: +new Date() };
        }
    }, doUpdateAiAssistVisiable_sd: (state, action) => {
        var _a;
        state.aiAssistSideBarVisiable_sd = action.payload;
        if (!!((_a = action.payload) === null || _a === void 0 ? void 0 : _a.visiable) && !!state.aiAssistSideBarVisiable) {
            state.aiAssistSideBarVisiable = false;
        }
    }, doReadMailFromAI: (state, action) => {
        const { uid, ownerId, mid } = action.payload || {};
        state.mailTPDetailQuery = {
            isSelf: false,
            mid,
            owner: uid || '',
            subEmail: uid || '',
            colleagueAccId: ownerId + '',
            mailFrom: 'subordinate',
        };
        const isSearching = !!state.subordinate[tabId.subordinate].mailSearchState;
        if (isSearching) {
            state.subordinate[tabId.subordinate].activeSearchMailId = mid;
            state.subordinate[tabId.subordinate].selectedMailId = {
                id: mid,
                owner: uid,
                subEmail: uid,
                colleagueAccId: ownerId + '',
                from: 'subordinate',
            };
        }
        else {
            state.subordinate[tabId.subordinate].selectedMailId = {
                id: mid,
                owner: uid,
                subEmail: uid,
                colleagueAccId: ownerId + '',
                from: 'subordinate',
            };
        }
    }, doUpdataCurrentFolderUnReadCount: (state, action) => {
        state.currentFolderUnReadCount = action.payload;
    }, doUpdateCurrentMergeMailId: (state, action) => {
        state.currentMergeMailId = action.payload;
    } });
const logicSlice = {
    doSwitchFolder: (state, action) => {
        state.realListCurrentPage = 1;
        const selectd = action.payload;
        const isSearching = getIsSearchingMailByState(state);
        if (!isSearching && (selectd.id !== state.selectedKeys.id || selectd.accountId !== state.selectedKeys.accountId)) {
            state.selectedKeys = {
                id: selectd.id,
                accountId: selectd.accountId,
                authAccountType: selectd.authAccountType,
            };
            state.listLoading = true;
            state.mailListStateTab = 'ALL';
            try {
                storageApi.putSync(MAIL_FOLDER_SELECTED_LOCAL_KEY, JSON.stringify({
                    id: selectd.id,
                    accountId: selectd.accountId,
                }));
            }
            catch (e) {
                console.error('[error] doSwitchFolder local', e);
            }
        }
        if (isSearching) {
            state.listLoading = true;
            state.searchListStateTab = 'ALL';
        }
        const key = selectd.id;
        let onKey;
        if ([FLOLDER.DEFAULT, FLOLDER.SENT, FLOLDER.REDFLAG].indexOf(key) !== -1) {
            onKey = key.toString();
        }
        else {
            onKey = '-100';
        }
        const onStatus = state.guidePageStatus[onKey];
        const onSort = guideConfig[onKey].sort;
        const nextStatus = guideConfig[onKey].sort[(onSort.indexOf(onStatus) + 1) % onSort.length];
        state.guidePageStatus[onKey] = nextStatus;
        state.onGuidePage = guideConfig[onKey].config[nextStatus];
        state.mailTagFolderActiveKey = {
            accountId: '',
            key: '',
        };
        state.scrollTop = 0;
    },
    mailOperCheck: (state, action) => {
        const id = action.payload;
        if (mailIdinList(id, state.activeIds)) {
            state.activeIds = [];
        }
    },
    resetMailList: (state) => {
        state.activeIds = [];
        state.selectedMailId = Object.assign({}, defaultSelectedMailId);
    },
    clearReadSelection: (state, action) => {
        const operatedIds = action.payload == null ? null : Array.isArray(action.payload) ? action.payload : [action.payload];
        const isSearching = getIsSearchingMailByState(state);
        const currentReadId = isSearching ? state.activeSearchMailId.id : state.selectedMailId.id;
        if (operatedIds != null && (!currentReadId || !operatedIds.includes(currentReadId))) {
            if (currentReadId) {
                state.activeIds = [currentReadId];
            }
            return;
        }
        state.activeIds = [];
        if (isSearching) {
            state.activeSearchMailId = Object.assign({}, defaultSelectedMailId);
        }
        else {
            state.selectedMailId = Object.assign({}, defaultSelectedMailId);
        }
    },
    activeNextMailById: (state, action) => {
        const mailId = action.payload;
        const { searchList, mailDataList, selectedMailId, activeSearchMailId } = state;
        const isSearching = getIsSearchingMailByState(state);
        const mailIdList = isSearching ? searchList : mailDataList;
        const mailList = getMailListByIdFromStore(mailIdList, state.mailEntities);
        const activeMialId = isSearching ? activeSearchMailId.id : selectedMailId.id;
        const ids = typeof mailId === 'string' ? [mailId] : mailId;
        const nextMailId = getCanActiveMailId(mailList, ids, activeMialId);
        if (nextMailId) {
            state.activeIds = [nextMailId];
            if (isSearching) {
                state.activeSearchMailId = {
                    id: nextMailId,
                    accountId: '',
                };
            }
            else {
                state.selectedMailId = {
                    id: nextMailId,
                    accountId: '',
                };
            }
        }
        else {
            state.activeIds = [];
            if (isSearching) {
                state.activeSearchMailId = {
                    id: '',
                    accountId: '',
                };
            }
            else {
                state.selectedMailId = {
                    id: '',
                    accountId: '',
                };
            }
        }
    },
    showMailMoveModal: (state, action) => {
        var _a;
        const { mailId, folderId, accountId } = action.payload || {};
        const { mailEntities } = state;
        const key = Array.isArray(mailId) ? mailId[0] : mailId;
        if (mailId && folderId != null) {
            state.mailMoveFid = folderId;
            state.mailMoveMid = {
                mailId: mailId,
                accountId: accountId || (mailEntities[key] ? (_a = mailEntities[key]) === null || _a === void 0 ? void 0 : _a._account : ''),
            };
            state.mfModalSelectedFids = [];
            state.mfModalExpandFids = [-2];
            state.mailMoveModalVisiable = true;
        }
    },
    showMailImportModal: (state, action) => {
        const { mailId } = action.payload || {};
        if (mailId) {
            state.mailMoveFid = -100001;
            state.mailImportMid = mailId;
            state.mfModalSelectedFids = [];
            state.mfModalExpandFids = [-2];
            state.mailImportModalVisible = true;
        }
    },
    showMailAITidyUpModal: (state, action) => {
        state.mailAITidyUpModalVisiable = true;
    },
    doMailReplay: (state, action) => {
        const { id, replayed, forwarded } = action.payload || {};
        const mail = state.mailEntities[id];
        if (mail) {
            mail.entry.replayed = replayed;
            mail.entry.forwarded = forwarded;
        }
    },
    doResetMailSearch: (state) => {
        state.mailSearching = '';
        state.mailSearchStateMap = {};
        state.selectedSearchKeys = {};
        state.defaultSelectedSearchKeyMap = {};
        state.expandedSearchKeys = [-2];
        state.listLoading = false;
        state.advanceSearchFromValues = {};
        state.searchResultObj = {};
        state.mailSearchAccount = '';
        state.searchList = [];
        state.searchListStateTab = 'ALL';
        state.mailSearchKey = '';
    },
    doMailDragStart: (state, action) => {
        state.folderTreeDragModel = action.payload;
        state.isDragModel = 'mail';
    },
    doMailDragEnd: (state) => {
        state.folderTreeDragModel = null;
        state.isDragModel = null;
    },
    doMailOperation: (state, action) => {
        const event = action.payload;
        const { eventData, eventStrData, _account } = event;
        const { selectedKeys, selectedMailId, hideMessage, successMsg, failMsg } = state;
        const isSearching = getIsSearchingMailByState(state);
        let list = getMailListByIdFromStore(isSearching ? state.searchList : state.mailDataList, state.mailEntities);
        if (eventStrData === 'redFlag') {
            const { id, mark } = eventData.params;
            const key = typeof id === 'string' || typeof id === 'number' ? id : id.join(',');
            const ids = typeof id === 'string' || typeof id === 'number' ? [id] : id;
            if (eventData.status === 'success') {
                if (!eventData.result || eventData.result.size === 0) {
                    reducerHelper.updateMailEntityByEvent(state.mailEntities, 'redFlag', eventData);
                }
            }
            else if (eventData.status === 'local' || eventData.status === 'fail') {
                reducerHelper.updateMailEntity(state.mailEntities, 'redFlag', eventData.result);
            }
        }
        else if (eventStrData === 'preferred') {
            const { id, mark } = eventData.params;
            const key = typeof id === 'string' || typeof id === 'number' ? id : id.join(',');
            if (eventData.status === 'success') {
            }
            else if (eventData.status === 'local' || eventData.status === 'fail') {
                reducerHelper.updateMailEntity(state.mailEntities, 'preferred', eventData.result);
            }
            if (eventData.status === 'fail') {
            }
        }
        else if (eventStrData === 'read') {
            const { id, mark } = eventData.params;
            const key = typeof id === 'string' || typeof id === 'number' ? id : id.join(',');
            if (eventData.status === 'success') {
                if (!eventData.result || eventData.result.size === 0) {
                    reducerHelper.updateMailEntityByEvent(state.mailEntities, 'read', eventData);
                }
            }
            else if (eventData.status === 'local' || eventData.status === 'fail') {
                reducerHelper.updateMailEntity(state.mailEntities, 'read', eventData.result);
            }
            else if (eventData.status === 'start') {
                const simpleResult = new Map();
                simpleResult.set(id, { readStatus: mark ? 'read' : 'unread' });
                console.log('zzzzzzzh simpleResult', simpleResult);
                reducerHelper.updateMailEntity(state.mailEntities, 'read', simpleResult);
            }
            if (eventData.status === 'fail') {
            }
        }
        else if (eventStrData === 'tag') {
            const { add, delete: _delete, isNewTag } = eventData.params;
            const tagNames = add || _delete || [];
            const _key = tagNames.join(',');
            if (eventData.status === 'success') {
                if (!eventData.result || eventData.result.size === 0) {
                    reducerHelper.updateMailEntityByEvent(state.mailEntities, 'tag', eventData);
                }
            }
            else if (eventData.status === 'local' || eventData.status === 'fail') {
                reducerHelper.updateMailEntity(state.mailEntities, 'tag', eventData.result);
            }
        }
        else if (eventStrData === 'reply') {
            if (eventData.status === 'local' || eventData.status === 'success' || eventData.status === 'fail') {
                reducerHelper.updateMailEntity(state.mailEntities, 'reply', eventData.result);
            }
        }
        else if (eventStrData === 'defer') {
            if (eventData.status === 'local' || eventData.status === 'fail') {
                reducerHelper.updateMailEntity(state.mailEntities, 'defer', eventData.result);
            }
            else if (eventData.status === 'success') {
                if (!eventData.result || eventData.result.size === 0) {
                    reducerHelper.updateMailEntityByEvent(state.mailEntities, 'defer', eventData);
                }
            }
        }
        else if (eventStrData === 'completeTrust') {
            reducerHelper.updateMailEntity(state.mailEntities, 'suspiciousSpam', eventData.result);
        }
        else if (eventStrData === 'requestReadReceiptLocal') {
            if (eventData.result) {
                reducerHelper.updateMailEntity(state.mailEntities, 'requestReadReceiptLocal', eventData.result);
            }
        }
        else if (eventStrData === 'memo') {
            if (eventData.result) {
                reducerHelper.updateMailEntity(state.mailEntities, 'memo', eventData.result);
            }
        }
        else if (eventStrData === 'markFolder') {
            if (eventData.status === 'local' || eventData.status === 'fail') {
                reducerHelper.updateMailEntity(state.mailEntities, 'markFolder', eventData.result);
            }
        }
    },
    doTaskMailOperation: (state, action) => {
        const event = action.payload;
        const { eventData, eventStrData } = event;
        const { taskMailList } = eventData;
        const isSearching = getIsSearchingMailByState(state);
        let list = getMailListByIdFromStore(isSearching ? state.searchList : state.mailDataList, state.mailEntities);
        if (eventStrData === 'refreshTaskList') {
            list.forEach(item => {
                const isChange = item.taskId && taskMailList.get(item.taskId);
                if (isChange) {
                    item.taskInfo = taskMailList.get(item.taskId);
                }
            });
        }
    },
    doUpdateMailId: (state, action) => {
        const { sliceId = '', stateName = '', mailList = [], type } = action.payload;
        const targetState = stateName && sliceId && type ? state[type][sliceId] : state;
        if (stateName && targetState[stateName] != null && mailList) {
            const idList = [];
            const idMap = {};
            mailList.forEach(mail => {
                var _a;
                const mailId = (_a = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _a === void 0 ? void 0 : _a.id;
                if (mailId && !idMap[mailId]) {
                    idMap[mailId] = true;
                    idList.push(mailId);
                }
            });
            if (sliceId && type && state[type][sliceId]) {
                state[type][sliceId][stateName] = idList;
            }
            else {
                state[stateName] = idList;
            }
            updateMailStore(state, mailList);
        }
    },
    updateMailEntities(state, action) {
        if (state[MAIL_STORE_REDUX_STATE]) {
            const { mailList = [] } = action.payload;
            updateMailStore(state, mailList);
        }
    },
    updateMailEntitiesNoMerge(state, action) {
        if (state[MAIL_STORE_REDUX_STATE]) {
            const { mailList = [] } = action.payload;
            updateMailStoreNoMerge(state, mailList);
        }
    },
    updateMailEntitiesExclude(state, action) {
        if (state[MAIL_STORE_REDUX_STATE]) {
            const { mailList = [], exclude } = action.payload;
            updateMailStore(state, mailList, exclude);
        }
    },
    reDrawMailList(state) {
        try {
            state.scrollTop = state.scrollTop % 2 === 0 ? state.scrollTop + 1 : state.scrollTop - 1;
        }
        catch (e) {
            console.error('[reDrawMailList err]', e);
        }
    },
    setStateByAccount(state, action) {
        const accountId = state.selectedKeys.accountId;
        const { stateName, payload } = action.payload;
        if (!accountId) {
            state.mainAccountState[stateName] = payload;
        }
        else {
            state.childAccountStateMap[accountId][stateName] = payload;
        }
    },
    updateAllReadLoading(state, action) {
        var _a, _b, _c, _d, _e, _f;
        const { folderId, loading, accountId } = action.payload;
        if (isMainAccount(accountId)) {
            if ((_b = (_a = state.mailTreeStateMap) === null || _a === void 0 ? void 0 : _a.main) === null || _b === void 0 ? void 0 : _b.allReadLoadingMap) {
                const loadingMap = Object.assign({}, (((_d = (_c = state.mailTreeStateMap) === null || _c === void 0 ? void 0 : _c.main) === null || _d === void 0 ? void 0 : _d.allReadLoadingMap) || {}));
                loadingMap[folderId] = loading;
                state.mailTreeStateMap.main.allReadLoadingMap = loadingMap;
            }
        }
        else {
            if ((_e = state.mailTreeStateMap[accountId]) === null || _e === void 0 ? void 0 : _e.allReadLoadingMap) {
                const loadingMap = Object.assign({}, (((_f = state.mailTreeStateMap[accountId]) === null || _f === void 0 ? void 0 : _f.allReadLoadingMap) || {}));
                loadingMap[folderId] = loading;
                state.mailTreeStateMap[accountId].allReadLoadingMap = loadingMap;
            }
        }
    },
    doUpdateOrderDateRange: (state, action) => {
        state.orderDateRange = action.payload;
    },
    updateCustomerAsideDetail: (state, action) => {
        state.customerAsideDetail = Object.assign(Object.assign({}, state.customerAsideDetail), action.payload);
    },
    updateCommonAsideDetail: (state, action) => {
        const { aiDetailMap, aiMidMap } = state.commonAsideDetail;
        state.commonAsideDetail = {
            aiDetailMap: Object.assign(Object.assign({}, aiDetailMap), (action.payload.aiDetailMap || {})),
            aiMidMap: Object.assign(Object.assign({}, aiMidMap), (action.payload.aiMidMap || {})),
        };
    },
    updateOuterFileDragEntry: (state, action) => {
        state.isDragModel = 'eml';
        state.folderTreeDragModel = null;
    },
    updateOuterFileDragLeave: (state, action) => {
        state.isDragModel = null;
        state.folderTreeDragModel = null;
    },
    chooseMailFromList: (state, action) => {
        const { key } = action.payload;
        const { mailEntities, mailDataList, searchList } = state;
        const isSearching = getIsSearchingMailByState(state);
        let idList = [];
        if (isSearching) {
            idList = getChooseMailId(searchList, mailEntities, key);
            state.activeIds = idList;
        }
        else {
            idList = getChooseMailId(mailDataList, mailEntities, key);
            state.activeIds = idList;
        }
        if (idList.length == 1) {
            state.defaultMailListSelectedModel = LIST_MODEL.MULTIPLE;
        }
        if (key == MAIL_LIST_CHOOSE_TYPE.READ && (idList === null || idList === void 0 ? void 0 : idList.length) == 0) {
            message.warn({
                content: getIn18Text('MEIYOUYIDUYOUJ'),
                duration: 1,
            });
        }
        if (key == MAIL_LIST_CHOOSE_TYPE.UNREAD && (idList === null || idList === void 0 ? void 0 : idList.length) == 0) {
            message.warn({
                content: getIn18Text('MEIYOUWEIDUYOUJ'),
                duration: 1,
            });
        }
    },
    doAddTagAfterDistribute: (state, action) => {
        const { mailId } = action.payload;
        const mail = state.mailEntities[mailId];
        if (mail) {
            const tags = mail.tags || [];
            if (!tags.includes('__deliveryrecord__')) {
                tags.unshift('__deliveryrecord__');
                mail.tags = tags;
            }
            if (mail.entry.systemLabel && !mail.entry.systemLabel.includes(3)) {
                mail.entry.systemLabel.push(3);
            }
            else if (!mail.entry.systemLabel) {
                mail.entry.systemLabel = [3];
            }
        }
    },
    doUpdateFollowStatus: (state, action) => {
        const { mailId, isFollowUp } = action.payload;
        const mail = state.mailEntities[mailId];
        if (mail) {
            mail.entry.isFollowUp = isFollowUp;
        }
    },
    doUpdateMailAttName: (state, action) => {
        var _a;
        const { mailId, file } = action.payload;
        try {
            const mail = state.mailEntities[mailId];
            (((_a = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _a === void 0 ? void 0 : _a.attachment) || []).forEach(_ => {
                if (!_.deleted && _.fileSize === file.fileSize && _.fileName === file.fileName) {
                    _.fileName = file.newName;
                }
            });
        }
        catch (error) {
            console.error('doUpdateMailAttName error', error);
        }
    },
    doUpdateCustomerMail: (state, action) => {
        const { mailId, accountId, query, type, tabId } = action.payload;
        state.activeIds = [];
        const isSearching = getIsSearchingMailByState(state);
        state.mailTPDetailQuery = query;
        if (type == 'customer') {
            try {
                if (tabId && state.customer) {
                    const cstate = state.customer[tabId];
                    if (cstate) {
                        cstate.selectedMailId = {
                            id: mailId || '',
                            accountId: accountId,
                            from: 'customer',
                            lock: true,
                        };
                    }
                }
            }
            catch (e) {
                console.log(e);
            }
        }
        else {
            if (isSearching) {
                state.activeSearchMailId = {
                    id: mailId || '',
                    accountId: accountId,
                    from: 'customer',
                    lock: true,
                };
            }
            else {
                state.selectedMailId = {
                    id: mailId || '',
                    accountId: accountId,
                    from: 'customer',
                    lock: true,
                };
            }
        }
    },
};
export const MailBoxSlice = Object.assign(Object.assign({}, staticSlice), logicSlice);
export * from './mailboxThunks';
